














import { Component, Prop, Vue } from 'vue-property-decorator'
@Component
export default class JSwitchComponent extends Vue {
    @Prop() private activeValue!: string;
    @Prop() private inActiveValue!: string;
    @Prop() private state!: string;

    set status(val: string) {}

    get status(): string {
        return this.state
    }
}
